import { boot } from 'quasar/wrappers';
import messages from 'src/i18n';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { createI18n, castToVueI18n } from 'vue-i18n-bridge'

declare module 'vue/types/vue' {
  interface Vue {
    i18n: VueI18n;
  }
}

Vue.use(VueI18n, {bridge: true});

export const i18n = castToVueI18n(createI18n({
  legacy: true,
  locale: 'en-us',
  fallbackLocale: 'en-us',
  messages
}, VueI18n));


 const i18nComposition = castToVueI18n(createI18n({
  legacy: false,
  locale: 'en-us',
  fallbackLocale: 'en-us',
  messages
}, VueI18n));

export default boot(({ app, Vue }) => {
  // Set i18n instance on app
  Vue.use(i18n);
  // Set the composition API i18n instance.
  Vue.use(i18nComposition);
  app.i18n = i18n;
});
